import { styled } from "@mui/system";
import { IconButton, Tab as MuiTab, Tabs as MuiTabs } from "@mui/material";

export const Tab = styled(MuiTab)({
  textTransform: "none",
  padding: "16px 24px",
  color: "#111",
  textAlign: "center",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  '&.Mui-selected': {
    fontWeight: '700',
    color: '#111',
  },
  '& .MuiTabs-indicator': {
    borderRadius: 0,
  },
});

export const RedTab = styled(MuiTab)({
  textTransform: "none",
  padding: "16px 24px",
  color: "var(--cherry)",
  textAlign: "center",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  "&.Mui-selected": {
    color: "var(--cherry)",
    borderBottom: "2px solid var(--blue)",
  },
  "&.Mui-focusVisible": {
    color: "var(--cherry)",
    borderBottom: "2px solid var(--blue)",
  },
});

export const HomeButton = styled(IconButton, {
  shouldForwardProp: (prop) =>
    !["fullWidth", "indicator", "selectionFollowsFocus", "textColor"].includes(
      prop as string,
    ),
})({
  padding: "8px",
});

export const StyledTabs = styled(MuiTabs, {
  shouldForwardProp: (prop) =>
    !["textColor", "indicator", "fullWidth"].includes(prop as string),
})({
  paddingLeft: "32px",
  minHeight: "46px",
  marginTop: "-5px",
});

export const DropdownContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "-8px",
  marginRight: "-8px",
});
